import PropTypes from 'prop-types'
import AsyncSelect from "react-select/async";

const FieldAsyncSelect = ({
                              id,
                              placeholder,
                              promiseOptions,
                              iconBefore,
                              iconAfter,
                              wrapperClasses,
                              inputClasses,
                              field,
                              form: {touched, errors, setFieldValue}
                          }) => {

    return (
        <div className={"mb-6 " + wrapperClasses}>
            <div className="field FieldAsyncSelect input-group flex py-2 mb-2 shadow">
                {iconBefore &&
                    <span
                        className="flex items-center justify-center text-gray-400	">
                   {iconBefore}
                </span>
                }
                <div className="relative w-full">
                    <AsyncSelect
                        cacheOptions
                        defaultOptions
                        styles={customStyles}
                        placeholder={placeholder}
                        value={field.value}
                        theme={(theme) => ({
                            ...theme,
                            colors: {
                                ...theme.colors,
                                primary25: 'rgba(150, 150, 150, 0.15)',
                                primary50: 'rgba(150, 150, 150, 0.25)',
                                primary: 'black',
                            },
                        })}
                        loadOptions={promiseOptions}
                        onChange={(selected) => setFieldValue(field.name, selected)}
                        isSearchable={false}
                    />
                </div>
                {
                    iconAfter &&
                    <span
                        className="flex items-center justify-center text-gray-400	">
                       {iconAfter}
                    </span>
                }

            </div>
            {touched[field.name] && errors[field.name] &&
                <p className="text-red-500 text-xs italic">{errors[field.name]}</p>
            }
        </div>
    )
}

export default FieldAsyncSelect

FieldAsyncSelect.propTypes = {
    type: PropTypes.string.isRequired,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    iconBefore: PropTypes.element,
    iconAfter: PropTypes.element,
    options: PropTypes.array,
    field: PropTypes.object,
    form: PropTypes.object,
    wrapperClasses: PropTypes.string,
    inputClasses: PropTypes.string,
    promiseOptions: PropTypes.func,
}

const customStyles = {
    control: (provided) => ({
        ...provided,
        border: 'none',
        boxShadow: "none"
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    placeholder: (provided) => ({
        ...provided,
        fontStyle: "italic"
    })
}
